import { useContext } from 'react'
import { UserContext } from '../../stores/User/UserStore'
import { UserActionTypes } from '../../stores/User/UserReducer'
import VouchermaticRepository from './vouchermatic.repository'
import { Membership } from '../../types'

const useVouchermaticRepository = () => {
    const { dispatch } = useContext(UserContext)

    const vouchermaticRepository = new VouchermaticRepository()

    const fetchWallet = async (membershipId: string) => {
        let walletUrl = ``

        return vouchermaticRepository.fetchWallet(membershipId)
            .then((result: string) => {
                walletUrl = result
            })
            .catch((error) => {
                walletUrl = error.toString()
            })
            .finally(() => {
                dispatch({
                    type: UserActionTypes.VOUCHERMATIC_WALLET_RETRIEVED,
                    vouchermaticWallet: walletUrl,
                })
            })
    }

    const createCustomer = async (membershipId?: Membership) => {
        let walletUrl = ``

        return vouchermaticRepository.createCustomer(membershipId)
            .then((result: string) => {
                walletUrl = result
            })
            .catch((error) => {
                walletUrl = error.toString()
            })
            .finally(() => {
                dispatch({
                    type: UserActionTypes.VOUCHERMATIC_WALLET_RETRIEVED,
                    vouchermaticWallet: walletUrl,
                })
            })
    }

    return {
        fetchWallet,
        createCustomer,
    }
}

export { useVouchermaticRepository }